import React from 'react'

const ChevronIcon = props => (
  <svg {...props} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.007 0l3.338 8.031L8.016 16H6l3.345-8.086L6.025 0h1.982z" />
  </svg>
)

export default ChevronIcon
